export const DEFAULT_TIMEOUT = {
  QUERY: 3_000,
  MUTATION: 7_000,
  /**
   * Cloud Run Job の起動 (`jobs:run`) をリクエストパスで待つエンドポイント向け。
   * コールドスタート時にトークン取得 + Admin API 呼び出しで数秒〜十数秒かかり、
   * 通常の MUTATION (7s) では AbortError → ユーザー再 submit による二重生成を招く。
   */
  MUTATION_WITH_JOB_DISPATCH: 60_000,
  /** GCS への CSV PUT など、大容量ファイルのアップロード */
  CSV_UPLOAD: 10 * 60 * 1_000,
} as const;
